// extracted by mini-css-extract-plugin
export default {"cls1":"nGcSYL6Vm1UFD_S7XdRX","cls2":"VDqNMbCMhJNLmtAUuQ48 nGcSYL6Vm1UFD_S7XdRX"};